module.exports = __webpack_public_path__ + "img/7.89b33ea8.jpg";